/* eslint-disable */

/**
 * @file index.js
 * @author huangwenming@baidu.com
 * @description 地图车主昊天镜入口文件
 */
var Haotianjing = {
  /**
   * 加载script文件
   * @param options {Object} script的传参
   * @required options.url script的路径
   */
  loadScript: function loadScript(options, successCB, failCB) {
    if (!options.url) {
      return;
    }

    var script = document.createElement('script');

    script.onerror = function () {
      script.parentNode.removeChild(script);
      failCB && failCB();
    };

    script.onload = function () {
      successCB && successCB();
    };

    if (options.attributes) {
      for (var key in options.attributes) {
        script.setAttribute(key, options.attributes[key]);
      }
    }

    script.src = options.url;
    script.type = 'text/javascript';
    document.body.appendChild(script);
  },

  /**
   * 引入昊天镜的js文件
   * @param jssdkKey JS SDK data-app参数(安全组提供的)
   * @param successCB 成功回调函数
   * @param failCB 失败回调函数
   */
  loadHaoTianJing: function loadHaoTianJing(jssdkKey, successCB, failCB) {
    var options = {
      'url': 'https://sofire.bdstatic.com/js/xaf.js',
      attributes: {
        'data-app': jssdkKey || 'eyJhcHBfa2V5IjoiMTM0MyIsImFwcF92aWV3IjoicHJvbW90ZSIsImZvcm1fZGVzYyI6IiIsInNlbmRfaW50ZXJ2YWwiOjUwLCJzZW5kX21ldGhvZCI6MywiYnJvd3Nlcl91cmwiOiJodHRwczovL3NvZmlyZS5iYWlkdS5jb20vZGF0YS91YS9hYi5qc29uIn0='
      }
    };
    Haotianjing.loadScript(options, successCB, failCB);
  },

  /**
   * 启用昊天镜，并初始化
   * @param options
   * options.cuid，端上携带的cuid，为必传参数
   * options.aid，安全组提供的渠道号id，为非必传参数，默认使用车主业务1343
   * options.jssdkKey，安全组提供的jssdk data-app参数，为非必传参数，默认使用车主业务
   * options.appType，页面环境参数，主要是区分系统，为非必传参数，默认只区分ios和android
   * options.successCb为非必传参数
   * options.failCb为非必传参数
   */
  enableHaoTianJing: function enableHaoTianJing(options) {
    Haotianjing.loadHaoTianJing(options.jssdkKey, function () {
      var ua = navigator.userAgent.toLowerCase();
      var appType = ua.indexOf('android') > -1 ? 'Android' : 'ios';
      var initParams = {
        // cuid
        c: options.cuid || '123',
        // 渠道号
        aid: options.aid || 1343,
        // 系统类型
        app: options.appType || appType
      };

      try {
        xaf.init(initParams);
        options.successCb && options.successCb();
      } catch (e) {
        options.failCb && options.failCb();
      }
    });
  }
};

export default Haotianjing;
